import React from 'react'

import { useAppSelector } from 'redux/hooks'
import { selectCollectionCards } from 'redux/collectionV2/selectors'

import TextCollectionCard, { TextCollectionCardHeader } from 'components/collectionV2/views/Text/TextCollectionCard'
import CardWrapper from 'components/collectionV2/views/CardWrapper'

import styles from './text.module.scss'

type Props = {}

const TextView = ({}: Props) => {
  const cardIds = useAppSelector(selectCollectionCards)
  const autoColumns = useAppSelector(state => state.collectionV2.autoColumns)

  return (
    <div className={`${styles.container} ${!autoColumns ? styles.bigTable : ''}`}>
      <TextCollectionCardHeader />

      <div className={styles.table}>
        {cardIds.map(collectionCardId => (
          <CardWrapper key={collectionCardId} component={TextCollectionCard} collectionCardId={collectionCardId} />
        ))}
      </div>
    </div>
  )
}

export default TextView
